"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  #atr-alto {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .caja-borde {\n    font-family: ", ", sans-serif;\n    font-size: 12px;\n    line-height: 1.2;\n    border-radius: ", ";\n  }\n  span {\n    font-family: ", ", sans-serif;\n    font-size: 12px;\n    line-height: 1.2;\n    font-weight: 600;\n  }\n  .icon {\n    width: 8px;\n    height: 8px;\n  }\n  .required-text {\n    color: red;\n  }\n"])), _variables.FontFamily.RobotoMedium, function (_ref) {
  var borderType = _ref.borderType;
  return (borderType === null || borderType === void 0 ? void 0 : borderType.toLowerCase()) === "rectangle" ? "5px" : (borderType === null || borderType === void 0 ? void 0 : borderType.toLowerCase()) === "circle" ? "50%" : "none";
}, _variables.FontFamily.RobotoMedium);

exports.Container = Container;